import { PORTFOLIO_INSTRUMENT_KIND_OBJ } from "../constants/portfolio-instrument.constants";
import type { PortfolioPositionRef } from "../types/portfolio-instrument";

/** Account and instrument kind are part of identity; JSON avoids delimiter collisions. */
export function getPortfolioPositionKey(position: PortfolioPositionRef): string {
  const instrumentId = position.kind === PORTFOLIO_INSTRUMENT_KIND_OBJ.SECURITY
    ? position.symbolId
    : position.optionContractId;
  return JSON.stringify([position.accountId, position.kind, instrumentId]);
}
